import { render, staticRenderFns } from "./RecordingTranscript.vue?vue&type=template&id=7d96196b&"
import script from "./RecordingTranscript.vue?vue&type=script&lang=js&"
export * from "./RecordingTranscript.vue?vue&type=script&lang=js&"
import style0 from "./RecordingTranscript.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports